import {type FC, memo} from "react";

import {StarFilledIcon} from "../../react/components/Icons";
import {HStack} from "../ui/hstack";
import type {IIConProps} from "../ui/icon";

type Props = {
    count: number;
    value: number;
    size?: IIConProps["size"];
};

const StarsRating: FC<Props> = ({count, value, size = "xs"}) => {
    return (
        <HStack space="2xs">
            {[...Array(count)].map((_, index) => (
                <StarFilledIcon
                    key={index}
                    fill={index < value ? "blueGray.600" : "blueGray.200"}
                    size={size}
                />
            ))}
        </HStack>
    );
};

export default memo(StarsRating);
